import React from 'react';

const Roadmap = () => {
    const timeline = [
        { date: "Dic 2025", title: "Transparentia", desc: "Lanzamiento del dashboard de auditoría de contratos" },
        { date: "Ene 2026", title: "Vibe Coding", desc: "Bootcamp gratuito de desarrollo con IA" },
        { date: "Mar-May 2026", title: "Hidrosensorial", desc: "Piloto de sensores IoT de presión hídrica" },
        { date: "Jun-Ago 2026", title: "Iztacalco Limpio", desc: "Mapeo de tiraderos · App de reportes" },
        { date: "Sep-Dic 2026", title: "Informe Anual", desc: "Publicación del 'Estado de Iztacalco 2026'" },
    ];

    return (
        <section id="roadmap" className="py-24 bg-background text-center">
            <div className="container mx-auto px-6">
                <span className="text-primary font-mono text-sm tracking-widest uppercase mb-4 block">PLAN DE ACCIÓN</span>
                <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-16">Roadmap 2026-2027</h2>

                {/* Desktop Horizontal Timeline */}
                <div className="hidden md:block relative max-w-5xl mx-auto">
                    {/* Horizontal Line */}
                    <div className="absolute top-4 left-0 right-0 h-0.5 bg-zinc-800"></div>

                    <div className="flex justify-between">
                        {timeline.map((item, i) => (
                            <div key={i} className="relative flex flex-col items-center w-1/5 px-2">
                                {/* Dot */}
                                <div className="w-4 h-4 bg-primary rounded-full border-4 border-background shadow-[0_0_12px_rgba(0,255,65,0.6)] z-10"></div>

                                <div className="mt-6 text-center">
                                    <span className="text-xs font-mono text-primary block mb-2">{item.date}</span>
                                    <h4 className="text-white font-bold text-sm mb-1">{item.title}</h4>
                                    <p className="text-xs text-zinc-500 leading-relaxed">{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Mobile Vertical Timeline */}
                <div className="md:hidden relative pl-6 text-left max-w-sm mx-auto">
                    <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-zinc-800"></div>
                    {timeline.map((item, i) => (
                        <div key={i} className="mb-8 relative">
                            <div className="absolute left-[-18px] top-1 w-3 h-3 bg-primary rounded-full border-2 border-background shadow-[0_0_10px_rgba(0,255,65,0.5)]"></div>
                            <span className="text-xs font-mono text-primary block mb-1">{item.date}</span>
                            <h4 className="text-white font-bold text-sm mb-1">{item.title}</h4>
                            <p className="text-xs text-zinc-500">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Roadmap;
